<template>
    <div class="formCom">
     <div class="form" >
       <button class="close" @click="closeModal">
         <CloseIcone></CloseIcone>
       </button>
         <div class="editlog">
           <table v-if="!isEmpty" class="styled-table">
             <thead>
               <tr>
                 <th class="title-data"></th>
                 <th class="title-data" v-for="kit in kitTypes" :key="`header-${kit}`">{{ kit }}</th>
               </tr>
             </thead>
             <tbody>
               <tr>
                 <td>FBA</td>
                 <td v-for="kit in kitTypes" :key="`amazon-${kit}`">{{ amazonCounts[kit] || 0 }}</td>
               </tr>
             </tbody>
           </table>
            <!-- Show a centered, red message if the table is empty -->
        <p v-else class="no-data-message">No data available</p>
         </div>
     </div>
   </div>
 </template>
 
 <script>
 import {mapGetters} from "vuex";
 import CloseIcone from "../../../images/shared/cancel";
 export default {
   name:'FbaInventoryTable',
   data() {
     return {
       kitTypes: ['F1', 'F2', 'F3', 'R1', 'R2', 'R3'],
     };
   },
   computed: {
     
     ...mapGetters(['getFilterSalesdata']),
     amazonCounts() {
      // Initialize counts for each kit type
      const counts = this.kitTypes.reduce((acc, kit) => {
        acc[kit] = 0;
        return acc;
      }, {});
      const kitTypes = {
        'B086D5RQ7N': 'F1',
        'B086D4464B': 'F2',
        'B086DCV9Q7': 'F3',
        'B0C7CXXSRH': 'R1',
        'B0C7D1RCQ4': 'R2',
        'B0C7D167SM': 'R3'
      };
      // Loop through getFilterSalesdata and sum the order_count for each kit type based on SKU
      this.getFilterSalesdata.forEach(item => {
        const kitType = kitTypes[item.type];  // Get the corresponding kit type for the SKU
        if (kitType && typeof item.order_count === 'number') {
          counts[kitType] += item.order_count;  // Add to the order_count for the kit type
        }
      });

      return counts; // Return the final counts object
    },
     isEmpty() {
      return !Array.isArray(this.getFilterSalesdata) || this.getFilterSalesdata.length === 0;
    }
   },
   methods: {
     closeModal() {
       this.$emit("closeInv", false);
     },
   },
   components: {
     CloseIcone
   },
 
 };
 </script>
 
 <style scoped>
 table {
   width: 100%;
   border-collapse: collapse;
 }
 th, td {
   padding: 8px;
 }
 
 th {
   background-color: #005eb8;
   color: #f5f7fa;
   text-align: left;
   font-family: TTNormsLight, sans-serif;
 }
 .headerp {
   color: #005eb8;
   font-size: 20px;
   font-family: TTNormsMedium, sans-serif;
 }
 .header{
   margin-bottom: 2%;
   display: -webkit-box;
   display: -ms-flexbox;
   display: flex;
   -webkit-box-pack: right;
   -ms-flex-pack: right;
   justify-content: right;
 }
 .container {
   padding-top: 30%;
   display: flex;
   justify-content: space-around;
   align-items: center;
   height: 200px; /* Adjust as needed for your layout */
 }
 .close {
   position: absolute;
   right: 15px;
   top: 15px;
   border: 1px solid transparent;
   cursor: pointer;
   width: 15px;
   height: 15px;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 0;
   background-color: transparent;
 }
 .formCom {
   background-color: rgba(219, 230, 241, 0.5);
   position: fixed;
   width: 100%;
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   left: 0;
   top: 0;
   z-index: 99;
 }
 .form {
   padding-top: 25px;
   background-color: #fff;
   max-width: 397px;
   width: 100%;
   position: relative;
   z-index: 1;
 }
 .no-data-message {
  color: red;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
  font-size: 14px;
  font-family: TTNormsLight,sans-serif;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.title-data {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.sort-data{
  padding-left: 10px;
}
.sort-data .down {
  transform: rotate(180deg);
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
  font-size: 14px;
  font-family: TTNormsLight,sans-serif;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.title-data {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.sort-data{
  padding-left: 10px;
}
.sort-data .down {
  transform: rotate(180deg);
}
 </style>
 